var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.groupOwnerType)?_c('div',{staticClass:"ui-label-group-owner"},[_c('div',{class:_vm.groupOwnerType})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }